import { Observable, Observer, Subject } from "rxjs";

import { Injectable } from "@angular/core";

@Injectable()
export class WebsocketService {
  private subject: Subject<MessageEvent> | null = null;

  public connect(url: string) {
    if (!this.subject) {
      this.subject = this.create(url);
      console.log("Successfully connected: " + url);
    }
    return this.subject;
  }

  public close() {
    this.subject?.complete();
    this.subject = null;
  }

  private create(url: string) {
    const ws = new WebSocket(url);

    const observable = new Observable((obs: Observer<MessageEvent>) => {
      ws.onmessage = obs.next.bind(obs);
      ws.onerror = obs.error.bind(obs);
      ws.onclose = obs.complete.bind(obs);
      return ws.close.bind(ws);
    });

    const observer = {
      next: (data: MessageEvent) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
        }
        if (data.data == '{"kind": "ping"}') {
          ws.send('{"kind": "pong"}');
        }
      },
      error: (err: unknown) => {
        console.group("ws error");
        console.log(err);
        console.groupEnd();
      },
      complete: () => {
        this.subject?.error("Webservice closed");
      },
    };

    const subject = new Subject<MessageEvent>();
    subject.subscribe(observer);
    observable.subscribe(subject);
    return subject;
  }
}
